export const WHEEL = [1.5, 2, 2.5, 3, 5];

export function computeRot(m) {
  const idx = WHEEL.indexOf(Number(m));
  return 360 * 6 + (360 - (idx < 0 ? 0 : idx) * 72 - 36);
}

export default function RaidWheel({ wheel }) {
  if (!wheel) return null;
  return (
    <div className="absolute top-6 left-6 flex flex-col items-center z-30" data-testid="raid-wheel">
      <div className="text-center mb-3 animate-fade-up">
        <div className="text-[#FFB703] font-800 tracking-widest text-xs" style={{ fontFamily: "Outfit, sans-serif" }}>🎉 RAID REWARD 🎉</div>
      </div>
      <div className="relative" style={{ width: 200, height: 200 }}>
        <div style={{ position: "absolute", top: -10, left: "50%", transform: "translateX(-50%)", width: 0, height: 0, borderLeft: "11px solid transparent", borderRight: "11px solid transparent", borderTop: "18px solid #fff", zIndex: 3, filter: "drop-shadow(0 2px 4px rgba(0,0,0,.6))" }} />
        <div style={{
          width: 200, height: 200, borderRadius: "50%", border: "5px solid #fff",
          boxShadow: "0 0 32px rgba(255,51,102,.6)",
          transform: `rotate(${wheel.rot}deg)`,
          transition: wheel.rot ? "transform 5s cubic-bezier(0.2,0.85,0.15,1)" : "none",
          background: "conic-gradient(#FF3366 0deg 72deg,#FFB703 72deg 144deg,#22c55e 144deg 216deg,#38bdf8 216deg 288deg,#a78bfa 288deg 360deg)",
        }}>
          {WHEEL.map((v, i) => (
            <div key={v} style={{ position: "absolute", top: "50%", left: "50%", transformOrigin: "0 0", transform: `rotate(${i * 72 + 36}deg) translate(0, -78px)` }}>
              <span style={{ display: "inline-block", transform: "translateX(-50%)", color: "#0a0a0a", fontWeight: 800, fontSize: 16, fontFamily: "Outfit, sans-serif" }}>{v}x</span>
            </div>
          ))}
        </div>
        <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%,-50%)", width: 34, height: 34, borderRadius: "50%", background: "#0a0a0a", border: "3px solid #fff", zIndex: 2 }} />
      </div>
      <div className="mt-3 text-2xl font-800 animate-fade-up" style={{ fontFamily: "Outfit, sans-serif", color: "#FFB703" }}>{wheel.rot ? `${wheel.multiplier}x COOKIES!` : "…"}</div>
    </div>
  );
}
